"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "body1ClassNames", {
    enumerable: true,
    get: function() {
        return _useBody1Stylesstyles.body1ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Body1"), exports);
const _useBody1Stylesstyles = require("./useBody1Styles.styles");
